import { useTranslations } from "next-intl";
import TimelineIndicator from "../timeline-indicator";
import {
  Box,
  Checkbox,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import StepIcon from "../step-icon";
import InfoIcon from "@mui/icons-material/Info";

const COLORS = {
  primary: "#004F45",
  success: "#00D639",
  cardBackground: "#E6F1F1",
  pageBackground: "#F5FAFA",
  iconBackground: "#DDEBEB",
  bodyText: "#666A6B",
  mutedText: "#979797",
  timeline: "#87AAA7",
};

const VerificationStep = ({ step, isLast }) => {
  const t = useTranslations("AAMultipleBankning");
  const title = t(`instructions.${step}.title`);
  const subtitle = t(`instructions.${step}.subtitle`);
  const tip = t.has(`instructions.${step}.tip`)
    ? t(`instructions.${step}.tip`)
    : null;
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: "24px minmax(0, 1fr)",
          md: "28px minmax(0, 1fr)",
        },
        columnGap: {
          xs: 1,
          md: 1.5,
        },
        width: "100%",
        minWidth: 300,
        alignItems: "stretch",
      }}
    >
      <TimelineIndicator isLast={isLast} />

      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          borderRadius: {
            xs: "7px",
            md: "9px",
          },
          bgcolor: COLORS.cardBackground,
          px: {
            xs: 2,
            md: 2.5,
          },
          py: {
            xs: 1.5,
            md: 2,
          },
          display: "flex",
          alignItems: "flex-start",
          gap: {
            xs: 1.5,
            md: 2,
          },
        }}
      >
        <StepIcon Icon={step} />

        <Box
          sx={{
            flex: 1,
            minWidth: 0,
            pt: {
              xs: 0.1,
              md: 0.25,
            },
          }}
        >
          <Typography
            sx={{
              color: COLORS.primary,
              fontWeight: 700,
              fontSize: {
                xs: "14px",
                md: "18px",
              },
              lineHeight: 1.35,
            }}
          >
            {title}
          </Typography>

          <Typography
            sx={{
              mt: 0.45,
              color: COLORS.bodyText,
              fontSize: {
                xs: "12px",
                md: "16px",
              },
              lineHeight: {
                xs: 1.45,
                md: 1.5,
              },
            }}
          >
            {subtitle}
          </Typography>

          {tip && (
            <Stack
              direction="row"
              spacing={0.65}
              alignItems="flex-start"
              sx={{
                mt: {
                  xs: 1.1,
                  md: 1.2,
                },
              }}
            >
              <InfoIcon
                sx={{
                  color: "#829C99",
                  fontSize: {
                    xs: 17,
                    md: 19,
                  },
                  mt: "1px",
                  flexShrink: 0,
                }}
              />

              <Typography
                sx={{
                  color: "#4F817C",
                  fontSize: {
                    xs: "12px",
                    md: "14px",
                  },
                  lineHeight: 1.45,
                  fontStyle: {
                    xs: "italic",
                    md: "normal",
                  },
                }}
              >
                {tip}
              </Typography>
            </Stack>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default VerificationStep;
